import React, { useMemo } from 'react'
import { rem } from 'polished'
import useOfferList from 'hooks/Offers/useOfferList'
import OfferCarouselHeader from './common/OfferCarouselHeader'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import { OFFER_TYPE_HOTEL, OFFER_TYPE_VILLA } from 'constants/offer'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import OfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import { ANYWHERE_PLACE_ID } from 'constants/search'

const SectionContainer = styled(VerticalSpacer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
  overflow-x: hidden;
`

const VILLA_OFFER_TYPES: App.OfferListOfferType[] = [OFFER_TYPE_VILLA, OFFER_TYPE_HOTEL]
const DEFAULT_FILTERS = {
  offerTypes: VILLA_OFFER_TYPES,
  holidayTypes: ['Homes & Villas'],
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
}

interface Props {
  sortBy?: 'value'
}

function VillaOfferCarousel(props: Props) {
  const { sortBy } = props
  const isManualSortingEnabled = isManualSortingEnabledFor('hotels')

  const defaultListFilters: App.OfferListFilters = useMemo(() => {
    if (isManualSortingEnabled && !sortBy) {
      return {
        offerTypes: VILLA_OFFER_TYPES,
        holidayTypes: ['Homes & Villas'],
        sortBy: 'carousel-hotel',
        limit: MAX_CAROUSEL_ITEM_COUNT,
      }
    } else {
      return {
        ...DEFAULT_FILTERS,
        sortBy,
      }
    }
  }, [isManualSortingEnabled, sortBy])

  const offerList = useOfferList(defaultListFilters)

  // temporarily directing the user to anywhere search with villa filter until villa vertical has been made

  const to = useMemo(() => {
    const query = {
      destinationId: ANYWHERE_PLACE_ID,
      destinationName: 'Anywhere',
      offerType: 'rental',
      adults: '2',
      children: 'none',
    }
    return `/search?${new URLSearchParams(query)}`
  }, [])

  if (offerList.offerIds.length === 0 && !offerList.fetching) {
    return null
  }

  return (
    <SectionContainer gap={20}>
      <LayoutContainer>
        <VerticalSpacer gap={20}>
          <OfferCarouselHeader allTo={to}>
            Unwind in our <i>homes & villas</i>
          </OfferCarouselHeader>
        </VerticalSpacer>
      </LayoutContainer>
      <OfferListCarousel
        filters={defaultListFilters}
        mobileLimit={8}
      >
        <OfferCarouselLookingForSomethingElse to={to} />
      </OfferListCarousel>
    </SectionContainer>
  )
}

export default React.memo(VillaOfferCarousel)
